import React from 'react';
import { BodyM } from 'components/Typography/Typography';
import { translate } from 'components/Translation';
import Card from 'assets/img/icons/card.svg';
import { makeStyles } from '@material-ui/core';
import styles from 'assets/jss/material-dashboard-pro-react/views/walletStyle';

// @ts-ignore
const useStyles = makeStyles(styles);

const NoCardsAdded = () => {
	const classes = useStyles();

	return (
		<div className={classes.noCardsAddedWrapper}>
			<BodyM disableMargin>{translate('wallet.no.cards.added')}</BodyM>
			<BodyM disableMargin>{translate('wallet.you.can.add.card')}</BodyM>
			<div className={classes.cardImageWrapper}>
				<img src={Card} alt="No cards added icon" />
			</div>
		</div>
	);
};

export default NoCardsAdded;
